import React, { useEffect, useState } from "react";
import pannlel2 from "../../../assets/images/image/buysell/pannlel2.jpg";
import { fetchData } from "../../../Components/common/utils";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
const Hero_Section = () => {
  const navigation = useNavigate();
  const [data, setData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setselectedCategory] = useState('')
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [productList, setProductList] = useState([])
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/slider";
      const result = await fetchData(url);
      if (result) {
        setData(result.data);
      }
    };
    fetchApiData();
    fetchCategory();
  }, []);
  const fetchCategory = async () => {
    const url = "api/category/all/list";
    const result = await fetchData(url);
    if (result) {
      setCategoryList(result.data);
    }
  };
  const fetchProducts = async (id) => {
    const url = "api/search/category/product/" + id;
    const result = await fetchData(url);
    if (result) {
      const newList = result.data.map(item => ({
        value: item.title,
        label: item.title,
        id: item.id,
        slug: item.slug,
        companyslug: item?.logo?.slug,
        varient: item.varient
      }));
      setProductList(newList);
    }
  };
  const handlechange = (e) => {
    if (e.target.value !== '') {
      fetchProducts(e.target.value);
    }
    setselectedCategory(e.target.value)
  }
  const handleProductChange = (value) => {
    setSelectedProduct(value)
  }
  const handlesearch = () => {
    if (selectedCategory === '') {
      return;
    } else if (selectedCategory !== '' && selectedProduct === null) {
      const category = categoryList.find(item => item.id === selectedCategory);
      navigation(`${category.slug}`)
    } else {
      const category = categoryList.find(item => item.id === selectedCategory);
      navigation(category.title.toLowerCase() === 'e-vehicles' ? `/${category.slug}/${selectedProduct.companyslug}/${selectedProduct?.slug}` :
        category.title.toLowerCase() === 'e-bikes' ? `/${category.slug}/${selectedProduct.companyslug}/${selectedProduct.varient ? selectedProduct?.slug : `detail/${selectedProduct?.slug}`}` : `/${category.slug}/${selectedProduct.companyslug}/${selectedProduct?.slug}`)
    }
  }
  return (
    <>
      <div
        id="carouselBasicExample"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        {/* <!-- Indicators --> */}
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselBasicExample"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          {data.slice(0, data.length - 1).map((item, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselBasicExample"
              data-bs-slide-to={index + 1}
              aria-label={`Slide ${index + 2}`}
            ></button>
          ))}

        </div>

        {/* <!-- Inner --> */}
        <div className="carousel-inner height_30em">
          {/* <!-- Single item --> */}
          {data.length > 0 ? data.map((item, index) => (
            <div key={index} className={`carousel-item height_30em ${index === 0 ? 'active' : ''}`}>
              <img
                src={item?.media[0]?.original_url}
                className="d-block w-100 height_30em background-overlay hero-img"
                alt="Sunset Over the City"
              />
              <div className="image-overlay">
                <div className="carousel-caption d-block  ">
                  <h2>{item?.short_title}</h2>
                  <p>{item?.long_title}</p>
                </div>
              </div>
            </div>
          )) : (
            <div className="carousel-item active height_30em">
              <img
                src={pannlel2}
                className="d-block w-100 height_30em  hero-img"
                alt="Canyon at Night"
              />
              <div className="image-overlay">
                <div className="carousel-caption d-block  d-md-block">
                  <h2>Clean Energy for a Greener</h2>
                </div>
              </div>
            </div>
          )}


        </div>

        {/* <!-- Controls --> */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselBasicExample"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselBasicExample"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <section className="box-search-position">
        <div className="container mt-4">
          <div className="search-bar d-flex justify-content-center">
            <div className="row w-100">
              <div className="col-md-4 col-sm-12 mb-2 mb-md-0">
                <select value={selectedCategory} onChange={handlechange} className="form-select h-100" aria-label="Default select example">
                  <option value='' selected>Select Category</option>
                  {categoryList.map((item, index) => (
                    <option key={index} value={item.id}>{item.title}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 col-sm-12 mb-2 mb-md-0">
                <Select
                  value={selectedProduct}
                  onChange={handleProductChange}
                  placeholder='Select Product'
                  options={productList}
                />
              </div>
              <div className="col-md-4 col-sm-12">
                <button onClick={handlesearch} disabled={selectedCategory === ''} className="btn btn-danger w-100">
                  <i className="fas fa-search"></i>Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero_Section;